import { Mapper } from "../../../../base/utils/mapper";
import { UserOtpModel } from "../../../../domain/models/user/user-otp.model";
import { UserOtpEntity } from "../entities/user-otp.entity";


export class UserOtpImplementationRepositoryMapper extends Mapper<UserOtpEntity, UserOtpModel> {
    mapFrom(param: UserOtpEntity): UserOtpModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserOtpModel): UserOtpEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}